// Type definitions for the Hey Immo widget

// Extend Window interface to include IS24.heyImmo

export var openImmoGpt = function openImmoGpt(message) {
  var customEvent = new CustomEvent('openImmoGpt', {
    detail: message ? {
      message: message
    } : undefined
  });
  window.dispatchEvent(customEvent);
};
export var openImmoGptEmpty = function openImmoGptEmpty() {
  var customEvent = new CustomEvent('openImmoGpt');
  window.dispatchEvent(customEvent);
};
export var configureHeyImmoWidget = function configureHeyImmoWidget(promptSuggestions) {
  var _window$IS;
  if ((_window$IS = window.IS24) !== null && _window$IS !== void 0 && (_window$IS = _window$IS.heyImmo) !== null && _window$IS !== void 0 && _window$IS.configure) {
    window.IS24.heyImmo.configure({
      promptSuggestions: promptSuggestions
    });
  }
};